// Import model
import { CreatePromptRequest } from '../models/CreatePromptRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreateMessageRequest } from '../models/CreateMessageRequest';

// Import dependency serializers (for complex types)
import { CreateMessageRequestSerializer } from './CreateMessageRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreatePromptRequest - handles JSON serialization and deserialization with type validation
 */
export class CreatePromptRequestSerializer {
  /**
   * Deserializes a JSON string into a CreatePromptRequest instance
   */
  static deserialize(json: string): CreatePromptRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreatePromptRequest instance
   */
  static fromObject(obj: any): CreatePromptRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreatePromptRequest');
    }


    const instance: CreatePromptRequest = {
      assistantId: obj['AssistantId'] as string,
      chatStatuses: obj['ChatStatuses'] ? (obj['ChatStatuses'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      messages: obj['Messages'] ? (obj['Messages'] as any[]).map((item: any) =>
        CreateMessageRequestSerializer.fromObject(item)
      ) : [],
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreatePromptRequest instances
   */
  static deserializeArray(json: string): CreatePromptRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreatePromptRequest instance to a JSON string
   */
  static serialize(instance: CreatePromptRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreatePromptRequest instance to a plain object
   */
  static toObject(instance: CreatePromptRequest): any {
    return {
      'AssistantId': instance.assistantId,
      'ChatStatuses': instance.chatStatuses?.map((item: any) =>
        item
      ),
      'Messages': instance.messages?.map((item: any) =>
        CreateMessageRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of CreatePromptRequest instances to a JSON string
   */
  static serializeArray(instances: CreatePromptRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
